import config from "@/utils/appConfig";
export default {
    history: [],
	isHash: false,
	isAddress: false,
	searchValue: null,
	searchType: '',
	canUndo: false,
	canRedo: false,
	coinType: 'btc',
	coinData: {
		key: 'btc',
		family: 'btc',
		label: 'BTC',
		baseUrl: config.VUE_APP_API_BASE_URL,
	},
  activeCoinData: null,
  currenciesListMap: {},
  currencyList: [],
	essentialCurrencyList: [],
	oldNewChain: {
		oldChain: {},
		newChain: {},
	},
	activeLayout: null,
	layoutsList: [
		{
			label: "Klay",
			value: "klay",
      icon: "I-Klay"
		},
    {
      label: "Hierarchy",
      value: "breadthfirst",
      icon: "I-Hierarchy"
    },
		{
			label: "Circle",
			value: "circle",
      icon: "I-Circle"
		},
    {
      label: "Cola",
      value: "cola",
      icon: "I-Cola"
    }
	],
	rightToolbarState: 52,
	modalPrivateCaseState: {
		message: '',
		open: false,
	},
	isGraphLoading: false,
	txTreeTotal: 0,
	txTreeIndex: 0,
  connectorMode: false,
	isStartPointVisible: false,
  activeBlockchainsList: [],
	isGlobalClusterSelected: false,
	openedAggregatedEdge: null,
	aggPopupPos: null,
	aggPopupZoom: 1,
	hoveredCommentCardId: null,
	hoveredCommentCardData: null,
	commentCardPos: null,
  findOnGraphValue: ''
}
